import React, { useState, memo } from 'react'
import './index.scss'

const DetailConsignmentBanner = () => {
  const floatTag = localStorage.getItem('floatTag')
  const [isOpen, setOpen] = useState(!!((floatTag && floatTag === 'show')))
  return (
    <>
      <div
        className={`r-detail-consignment-banner-s ${isOpen ? 'close' : ''}`}
        onClick={() => {
          global.$rbl.push({
            event: 'car-detail_detail_promisesellbanner_click',
            content: { param: { value: '优选概念-悬浮标签', page_name: '详情页' } }
          })
          setOpen(true)
          localStorage.setItem('floatTag', 'show')
        }}
        data-exposure={JSON.stringify({
          event: 'detail_promisesellbanner_display',
          content: { param: { value: '优选概念条-悬浮标签', page_name: '详情页' } }
        })}
      />
      <a
        href="https://www.renrenche.com/p/6/yanxuanshangcheng"
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          e.stopPropagation()
          global.$rbl.push({
            event: 'car-detail_detail_promisesellbanner_click',
            content: {
              param: {
                value: '优选概念-悬浮条跳转',
                page_name: '详情页'
              }
            }
          })
        }}
      >
        <div className={`r-detail-consignment-banner-l ${isOpen ? '' : 'close'}`}>
          <div className="text" />
          <i
            className="close-btn iconfont icon-close"
            data-exposure={JSON.stringify({
              event: 'detail_promisesellbanner_display',
              content: { param: { value: '优选概念条-悬浮标签', page_name: '详情页' } }
            })}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              global.$rbl.push({
                event: 'detail_promisesellbanner_click',
                content: { param: { value: '优选概念-悬浮条收起', page_name: '详情页' } }
              })
              setOpen(false)
              localStorage.setItem('floatTag', 'hide')
            }}
          />
        </div>
      </a>
    </>
  )
}

export default memo(DetailConsignmentBanner)
